import { useRef, useState, useEffect } from 'react';
import s from './style.module.scss';
import RootLayout from '../../Layout';
import Img from '../../Img';
import { useAuth } from '@/stores/AuthContext';
import { useTranslation } from 'react-i18next';
import { openDuetAppOrOneLink } from '@/util/oneLinkUtils';
import { isWingLocalLoggedIn } from '@/component/playgroundMobile/localPlayground/storage';
import MatchmakingEntry from '../MatchmakingEntry';

function HomeMobile({ props }: { props: any }) {
  const { t } = useTranslation();
  const { activeIndex, TitleColorMap, backgroundArrMobile, isWing, onLoginClick } = props;
  const { logged } = useAuth();
  const buttonRef = useRef<HTMLDivElement>(null);
  const [wingLogged, setWingLogged] = useState(false);

  useEffect(() => {
    if (isWing) {
      setWingLogged(isWingLocalLoggedIn());
    }
  }, [isWing]);

  const showPlay = isWing ? wingLogged : logged;

  return (
    <>
      <RootLayout className={s.wrapper} style={{ backgroundImage: `url(${backgroundArrMobile[activeIndex]})` }}>
        <>
          <div className={s.brandRow}>
            <Img
              className={s.logo}
              src="https://cdn.duetapp.net/v1/images/eyJpZCI6IjJCTUwzQ0hOR0xFN0xRUFQ2TU1DU1gyQUNVUE5URSIsInciOjIxNiwiaCI6NjQsImQiOjAsIm10IjoiaW1hZ2UvanBlZyIsImRoIjoxMDI1NTY2MTc3NTgzNDU2MzN9"
            />
            {!isWing && <MatchmakingEntry compact />}
          </div>
          <div className={s.buttonWrapper}>
            <div className={s.title}>Log in and "More ways to pay — just for you"</div>
            <div className={s.arrow} />
            <div
              ref={buttonRef}
              className={s.button}
              rel="noreferrer"
              style={{ color: TitleColorMap[activeIndex] }}
              onClick={() => {
                if (isWing) {
                  onLoginClick?.();
                  return;
                }
                if (logged) {
                  onLoginClick?.();
                } else {
                  openDuetAppOrOneLink();
                }
              }}
            >
              {showPlay ? 'Play' : 'Login'}
            </div>
          </div>
        </>
      </RootLayout>
    </>
  );
}

export default HomeMobile;
